/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  TemplateBare,
  TemplateFull,
  TemplateUpdate,
  TemplateVariable,
} from 'SharedDir/declarations/templates';
import {
  ADMINISTRATION_TEMPLATES,
  templatesUrl,
} from 'SharedDir/backend/endpoints/administration-templates';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

export default class TemplatesApiClass extends SimpleApi<
TemplateFull,
TemplateUpdate,
TemplateUpdate,
TemplateBare
> {
  constructor() {
    super(templatesUrl);
  }

  async variables() {
    const { data } = (await http({
      ...ADMINISTRATION_TEMPLATES.VARIABLES,
    })) as AxiosResponse<TemplateVariable[]>;
    return data;
  }

  async render(id: number) {
    const { data } = (await http({
      ...ADMINISTRATION_TEMPLATES.RENDER(id),
    })) as AxiosResponse<object>;
    return data;
  }
}
